// JavaScript Document
var BookingApp = angular.module('BookingApplication', ['ui.bootstrap','slugifier','daterangepicker']);

BookingApp.constant('dateRangePickerConfig', {
    clearLabel: 'Clear',
    locale: {
        separator: ' - ',
        format: 'MMM DD'
    }
});
